import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    codes: {
      display: 'grid',
      gridTemplateColumns: '7fr 3fr',
      gap: '30px',
    },
    headerPart: {
      padding: '24px 46px 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    helper: {
      cursor: 'pointer',
      display: 'flex',
      color: `${accentColor}`,
      fontWeight: 'bold',
      textDecoration: 'underline',
    },
    icon: {
      marginRight: '6px',
    },
    title: {
      color: accentColor,
      fontSize: '24px',
      display: 'flex',
    },
  }
}
